import { Avatar, Box, IconButton, Typography } from "@mui/material";
import { DeleteUserIcon } from "../../../../assets/icons/MUI/EventsIcons";
import { UserInfo } from "../../../../types";
import { useDataFormatter } from "../../../../hooks/useDataFormatter";

const SelectedUserCard = ({
  user,
  onDeleteFunction,
}: {
  user: UserInfo;
  onDeleteFunction: (id: number | null) => void;
}) => {
  const { media, firstTwoChr, fullName, id } = useDataFormatter(user);
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        rowGap: "8px",
        alignItems: "center",
        maxWidth: "56px",
      }}
    >
      <Avatar src={media || ""} sx={{ width: "52px", height: "52px" }}>
        {firstTwoChr}
      </Avatar>
      <Typography
        variant="body13Regular"
        sx={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%",
        }}
      >
        {fullName}
      </Typography>
      <IconButton
        onClick={() => onDeleteFunction(id)}
        sx={{
          background: "#106048 !important",
          border: "1px solid #FFF !important",
          padding: "3.5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "0",
          right: 0,
        }}
      >
        <DeleteUserIcon />
      </IconButton>
    </Box>
  );
};

export default SelectedUserCard;
